define('views/components/customer_note/customer_note_list',['require','views/base/list_view','views/components/customer_note/customer_note','text!templates/components/customer_note/customer_note_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/customer_note/customer_note');

    var temp = require("text!templates/components/customer_note/customer_note_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

